<template>
  <div class="home">
    <img :src="gif" class="gif" />
  </div>
</template>

<script>
/* istanbul ignore file */

export default {
  computed: {
    gif() {
      return require(`@/assets/gifs/tenor(${Math.floor(
        Math.random() * (15 - 0 + 1) + 0
      )}).gif`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.home {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $fourth_color;

  .gif {
    height: 50vh;
    padding: 10px;
    background: white;
  }

  .ant-layout-content {
    padding: 0;
  }
}
</style>
